export default __webpack_public_path__ + "static/media/default-avatar.8d0fd1b6.png";